module.exports = __webpack_public_path__ + "media/images/logo/gigbase_logo-c04d6f0fb759bd40ed5156d6db46635b.svg";